import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import { Paper } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    padding: 30,
    background: 'rgba(255,2555,255,0.5)'
  },
  moreInfo: {
    minHeight: 125
  },
  collapseButton: {
    textAlign: 'right',

    '& p': {
      color: '#002380',
      fontSize: 14,
      fontWeight: 'bold'
    }
  },
  button: {
    '&:hover': {
      background: 'none !important'
    }
  }
}));

const CollapseContainer = ({ children }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Paper className={classes.root} elevation={0}>
      {children}
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <div className={classes.moreInfo} />
      </Collapse>
      <div className={classes.collapseButton}>
        <IconButton
          aria-expanded={expanded}
          aria-label="show more"
          classes={{ root: classes.button }}
          onClick={handleExpandClick}>
          <p>{expanded ? '- show less' : '+ show more'}</p>
        </IconButton>
      </div>
    </Paper>
  );
};

export default CollapseContainer;
